import { onUserChange, User } from '@hub/shared'
import { SqLoader } from '@squidit/react-css'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'

export default () => {
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)

  const [isLoading, setIsLoading] = useState(true)
  const [user, setUser] = useState<User | null>(null)

  const { t } = useTranslation('header')

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe((userChanged: User) => {
      setUser(userChanged)
      setIsLoading(false)
    })

    return () => onUserChangeSubscription.current?.unsubscribe()
  }, [])

  const displayName = useMemo(() => {
    const socialName = user?.profileadditionalinfo?.socialName
    if (socialName) {
      return socialName
    }
    return user?.profileadditionalinfo?.name?.split(' ')?.[0] ?? ''
  }, [user])

  if (isLoading) {
    return (
      <div className="text-center py-3" style={{ width: '100%' }}>
        <SqLoader size="big" />
      </div>
    )
  }

  return (
    <div className="header container py-5" style={{ backgroundColor: 'var(--black)' }}>
      <h3 className="mb-5" style={{ color: 'var(--white)' }}>
        {t('hello', { name: displayName })}
      </h3>
    </div>
  )
}
